var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "8Qxt8S"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1667 36.4558C12.1996 23.0232 23.119 12.1429 36.5373 12.171C49.9654 12.2002 60.8604 23.128 60.8275 36.5387C60.7946 49.9664 49.8618 60.8613 36.4557 60.826C23.0215 60.7906 12.1351 49.8677 12.168 36.457L12.1667 36.4558ZM32.9454 28.1302C32.9454 29.731 32.9345 31.3318 32.9528 32.9326C32.9576 33.3298 32.8492 33.5819 32.5227 33.8427C30.6743 35.3192 29.9372 37.2587 30.4648 39.56C30.9753 41.7833 32.4288 43.2379 34.6512 43.7508C36.9479 44.282 38.8925 43.5547 40.3741 41.7078C40.6324 41.3861 40.8834 41.2668 41.2842 41.2692C44.223 41.2838 47.1618 41.2984 50.1006 41.2582C50.6855 41.2497 51.3227 41.1145 51.8393 40.8489C53.0126 40.2458 53.5584 38.8473 53.2404 37.5779C52.9042 36.2353 51.7308 35.3034 50.3016 35.2973C47.3421 35.2839 44.3839 35.2814 41.4243 35.3034C40.9163 35.307 40.5641 35.2022 40.2656 34.7527C40.0256 34.3909 39.6698 34.0863 39.3141 33.8256C39.0192 33.6087 38.9156 33.3858 38.9181 33.024C38.9327 29.8626 38.9315 26.7012 38.9242 23.5398C38.9205 21.7246 37.6424 20.4076 35.9135 20.4137C34.2065 20.4198 32.9576 21.7148 32.9479 23.5093C32.9394 25.0492 32.9454 26.5891 32.9454 28.1302Z",
    fill: "url(#paint0_linear_1_2353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.0211 65.2836C12.9867 66.1827 11.9632 67.0721 10.9397 67.9614C10.7411 68.1344 10.5389 68.3049 10.3427 68.4804C9.97355 68.8093 9.50568 68.9518 9.11457 68.6863C8.80144 68.4743 8.46881 68.0662 8.42495 67.7116C7.90225 63.388 7.42586 59.0583 6.94946 54.7286C6.81787 53.5347 7.5148 52.9804 8.66619 53.3422C12.6041 54.5812 16.5408 55.8263 20.4799 57.0616C20.9745 57.2163 21.3742 57.4539 21.4948 57.9948C21.6166 58.5418 21.3425 58.9194 20.9489 59.2569C19.9365 60.1255 18.9337 61.0063 17.8822 61.92C18.0772 62.0735 18.2246 62.2002 18.383 62.3111C36.9637 75.2088 62.5356 65.2873 67.3641 42.9456C68.5436 37.4865 68.1988 32.0689 66.4979 26.7439C66.1823 25.7559 66.2603 25.5086 67.0985 24.8909C67.6529 24.4816 68.2073 24.0722 68.7629 23.6641C69.7668 22.9283 70.4991 23.1427 70.906 24.3C72.4778 28.7674 73.1808 33.37 72.9603 38.0981C72.6289 45.1738 70.4906 51.6671 66.3724 57.438C60.3278 65.9062 52.1341 71.0582 41.8361 72.5786C31.7781 74.0637 22.6194 71.6418 14.4402 65.5809C14.3123 65.4859 14.1795 65.3982 14.0187 65.2849L14.0211 65.2836Z",
    fill: "url(#paint1_linear_1_2353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M58.9611 7.72153C60.1392 6.69697 61.2894 5.70531 62.4274 4.69902C62.8441 4.33111 63.2706 4.04603 63.8481 4.27141C64.4488 4.50532 64.5596 5.01699 64.623 5.59566C65.0799 9.76456 65.5538 13.931 66.0327 18.0975C66.1923 19.4851 65.5453 20.0272 64.1965 19.6033C60.3159 18.3813 56.4377 17.1546 52.5547 15.9399C52.0393 15.7791 51.6116 15.5501 51.4922 14.9799C51.3704 14.4025 51.6957 14.0297 52.1002 13.6825C53.0981 12.8285 54.0838 11.9599 55.1121 11.0632C54.8916 10.8951 54.7259 10.7562 54.548 10.6344C48.2829 6.3315 41.36 4.4444 33.7863 5.09252C19.4116 6.32175 7.77458 17.0668 5.38529 31.312C4.53606 36.3751 4.92229 41.3675 6.49526 46.2613C6.80229 47.2164 6.71822 47.4893 5.92748 48.0741C5.34021 48.5078 4.75659 48.9451 4.16566 49.374C3.23236 50.0513 2.48304 49.8247 2.10046 48.7356C0.427592 43.9734 -0.259589 39.076 0.0876568 34.0324C0.550651 27.282 2.66824 21.0969 6.59395 15.5952C12.7286 6.99545 21.0442 1.81661 31.5311 0.37053C41.4526 -0.996362 50.459 1.43529 58.5127 7.38895C58.6418 7.48519 58.7722 7.58143 58.9611 7.72153Z",
    fill: "url(#paint2_linear_1_2353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M37.9935 38.2893C37.9972 39.448 37.0663 40.3836 35.9173 40.3763C34.7817 40.369 33.8252 39.398 33.8423 38.2698C33.8593 37.1454 34.7768 36.2377 35.9063 36.228C37.0785 36.2194 37.9899 37.1185 37.9935 38.2881V38.2893Z",
    fill: "url(#paint3_linear_1_2353)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2353",
    x1: 36.4078,
    y1: 4.31231,
    x2: 36.4603,
    y2: 60.8261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2353",
    x1: 39.8455,
    y1: 15.1981,
    x2: 39.8859,
    y2: 73.0039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2353",
    x1: 32.907,
    y1: -8.03653,
    x2: 32.9474,
    y2: 49.7569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2353",
    x1: 35.9102,
    y1: 35.5579,
    x2: 35.9146,
    y2: 40.3763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9c5212154c045868292b80ad5e70825e.svg";
export { ForwardRef as ReactComponent };